/* eslint-disable no-unused-expressions */
// https://gist.github.com/strinkaus-gd/68f8b5cf7bebab50930357b2eab58fb9
// https://gitlab.messagebird.io/frontend/react-dashboard/-/blob/188a463e8f490bbcb2046c14131074ef5d92ea5c/src/helpers/analyticsNew/store.ts
import { useEffect, useState } from 'react';

export function createStore<T>(state: T) {
  let storeState: T = Object.assign({}, state);
  const storeSetters = new Set<(state: T) => void>();

  const setStoreState = (state: Partial<T>) => {
    storeState = Object.assign({}, storeState, state);
    storeSetters.forEach((setter) => setter(storeState));
  };

  function useStore(): [T, typeof setStoreState] {
    const [state, setState] = useState(storeState);
    useEffect(() => {
      () => storeSetters.delete(setState); //eslint-disable-line @typescript-eslint/no-unused-expressions
    }, []);
    storeSetters.add(setState);
    return [state, setStoreState];
  }

  return useStore;
}
